/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Otp_Changeemail1Inputs */

const he_auth_otp_changeemail1 = /** @type {(inputs: Auth_Otp_Changeemail1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`השתמשו באימייל אחר`)
};

const en_auth_otp_changeemail1 = /** @type {(inputs: Auth_Otp_Changeemail1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Use a different email`)
};

/**
* | output |
* | --- |
* | "Use a different email" |
*
* @param {Auth_Otp_Changeemail1Inputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
const auth_otp_changeemail1 = /** @type {((inputs?: Auth_Otp_Changeemail1Inputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Otp_Changeemail1Inputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_auth_otp_changeemail1(inputs)
	return en_auth_otp_changeemail1(inputs)
});
export { auth_otp_changeemail1 as "auth_otp_changeEmail" }